import AppNavbar from "@/components/layout/AppNavbar";
import Footer from "@/components/layout/Footer";
import { SUPPORT_EMAIL } from "@/shared/constants/support";

import { Col } from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "@/assets/css/style.css";

function ContactUs() {
  return (
    <>
      <AppNavbar />
      <main className="container-lg nav-padding">
        <Col lg={{ span: 8, offset: 2 }} className="py-5">
          <h2 className="mb-4">Contact Us</h2>
          <p>Favluv is provided as a service by Wishcan Inc</p>

          <address>
            <strong>Wishcan Inc.</strong>
            <br />
            2233 Wind River Ln
            <br />
            Rowland Heights, CA, 91748
            <br />
            Email:{" "}
            <span className="email">
              {SUPPORT_EMAIL}
            </span>
          </address>
        </Col>
      </main>
      <Footer />
    </>
  );
}

export default ContactUs;
